<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      :sticky="true"
      @load="onLoad"
    >
      <div v-for="item in newsList" :key="item.id">
        <NewsCell
          v-if="item.listType == 0 || item.listType == 4 || item.listType == 7"
          :item="item"
        />
        <TopicCell
          v-if="item.listType == 1 || item.listType == 5"
          :item="item"
        />
        <PicturesCell v-if="item.listType == 2" :item="item" />
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import {
  List,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  PullRefresh,
  Icon,
  Button,
  Image as VanImage,
  ImagePreview,
  Empty,
} from "vant";
import useDateDiff from "@/composiables/useDateDiff.js";
import NewsCell from "../components/NewsCell.vue";
import TopicCell from "../components/TopicCell.vue";
import PicturesCell from "../components/PicturesCell.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
export default {
  name: "NewsList",
  components: {
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Empty.name]: Empty,
    NewsCell,
    TopicCell,
    PicturesCell,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const page = ref(1);

    const onLoad = () => {
      const params = {
        page: page.value,
        pageSize: 20,
      };
      store.dispatch("getNewsList", { params, loading, finished, refreshing });
      page.value++;
    };

    const onRefresh = () => {
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    const imgClick = (item, index) => {
      console.log(item, index);
      ImagePreview({
        images: item.listImgs,
        startPosition: index,
        closeable: true,
      });
    };

    const toPlus = (item) => {
      // window.location.href = item.url;
      window.open(item.url, "_blank");
    };

    const handleClick = (id) => {
      router.push("/detail/" + id);
    };

    const dealDate = (dateString) => {
      return useDateDiff(dateString);
    };
    return {
      imgClick,
      handleClick,
      dealDate,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      newsList: computed(() => store.state.newsData),
      toPlus,
      // setImgBind,
      // imageColumnNum: computed(() => {
      // console.log(store.state.contents);
      // return 1
      // })
    };
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  --van-cell-border-color: #e0e0e0;
  margin: 3px 0;
}
.content {
  margin-top: 5vw;
  padding-bottom: 90px;
  --van-pull-refresh-head-text-color: white;
}

.content-list {
  --van-list-text-color: #5190d5;
}
.group-top {
  margin: 0px 20px;
  margin-bottom: 12px;
  background-color: white;
  padding: 12px 0;
}
.custom_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
  margin-bottom: 10px;
}
.list-title {
  color: #1c1c1c;
  font-size: 3.8vw;
  span {
    width: 47px;
    height: 23px;
    background: #ff8831;
    font-size: 3.6vw;
    color: #ffff;
    padding: 4px 10px;
    border-radius: 14px;
    margin-right: 15px;
  }
}
.title-more {
  font-weight: bold;
  margin-top: 5px;
}
.wrap {
  padding-right: 10px;
}
.list-content {
  width: 100%;
  font-size: 4vw;
  color: #1c1c1c;
  text-align: left;
  white-space: pre-wrap;
}
.custom-box {
  display: flex;
  margin: 6px 0px 0px 1px;
  // flex-wrap: wrap;
  // margin: 6px 0;
}
.custom-img {
  display: flex;
  --van-grid-item-content-padding: 0;
  flex-grow: 1;
  // margin: 6px 0;
}
.custom_imgs {
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}
.content-image {
  --van-grid-item-content-padding: 0;
  // margin: 4px;
  display: flex;
  width: 100%;
}
.content-image3 {
  width: 100%;
  --van-grid-item-content-padding: 0;
  flex-basis: 95% !important;
}
.img1 {
  /*1张图 */
  width: 66%;
}
.img2 {
  /*2张图*/
  width: 33%;
  margin-right: 10px;
}
.img3 {
  /*3、4、5、6张图*/
  width: 32%;
  margin-right: 10px;
}
.custom_detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail_left {
  display: flex;
  align-items: center;
}
.left {
  margin-left: 7px;
}
.van-button--default {
  margin-left: -10px;
  margin-top: 6px;
  font-size: 3vw;
  color: #c0c4cc;
  background: var(--van-button-default-background-color);
  border: var(--van-button-border-width) solid
    var(--van-button-default-border-color);
}
.wish-btn {
  padding: 15px 30px;
  text-align: center;
}

.custom-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .list-image {
    width: 108px;
    height: 72px;
    // margin: 0 10px 0px 16px;
    margin: 0 0px 0px 10px;
  }
}
</style>
